import QuartzDashboardView from "src/sections/dashboards/platforms/quartz/quartz-dashboard-view";

const QuartzCustomDashboardPage = () => <QuartzDashboardView type="custom" />;

export default QuartzCustomDashboardPage;
